'use strict';

exports.__esModule = true;
exports.MicroStar_I = exports.MicroStar_H = exports.MicroStar_G = exports.MicroStar_F = exports.MicroStar_E = exports.MicroStar_D = exports.MicroStar_C = exports.MicroStar_B = exports.MicroStar_A = exports.WF_MICRO_STAR_I = exports.WF_MICRO_STAR_H = exports.WF_MICRO_STAR_G = exports.WF_MICRO_STAR_F = exports.WF_MICRO_STAR_E = exports.WF_MICRO_STAR_D = exports.WF_MICRO_STAR_C = exports.WF_MICRO_STAR_B = exports.WF_MICRO_STAR_A = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WF_MICRO_STAR_A = exports.WF_MICRO_STAR_A = 'WF_MICRO_STAR_A';
var WF_MICRO_STAR_B = exports.WF_MICRO_STAR_B = 'WF_MICRO_STAR_B';
var WF_MICRO_STAR_C = exports.WF_MICRO_STAR_C = 'WF_MICRO_STAR_C';
var WF_MICRO_STAR_D = exports.WF_MICRO_STAR_D = 'WF_MICRO_STAR_D';
var WF_MICRO_STAR_E = exports.WF_MICRO_STAR_E = 'WF_MICRO_STAR_E';
var WF_MICRO_STAR_F = exports.WF_MICRO_STAR_F = 'WF_MICRO_STAR_F';
var WF_MICRO_STAR_G = exports.WF_MICRO_STAR_G = 'WF_MICRO_STAR_G';
var WF_MICRO_STAR_H = exports.WF_MICRO_STAR_H = 'WF_MICRO_STAR_H';
var WF_MICRO_STAR_I = exports.WF_MICRO_STAR_I = 'WF_MICRO_STAR_I';

var MicroStar_A = exports.MicroStar_A = function MicroStar_A(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default['wrapper_vertical'], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || '', props.isShrinked && _style2.default['wrapper--shrinked'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            {
                className: [_style2.default['verbal-rating'], props.isShrinked && _style2.default['verbal-rating--shrinked'] || ''].join(' ')
            },
            _react2.default.createElement(_widgetsUtils.VerbalRating, { rate: props.averageRating, isRateBold: 'true', isShrinked: props.isShrinked })
        ),
        _react2.default.createElement(
            'div',
            {
                className: [props.isShrinked ? '' : _style2.default['mb'], props.isShrinked && _style2.default['stars--shrinked'] || ''].join(' ')
            },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT,
                isShrinked: props.isShrinked
            })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: props.isShrinked ? _widgetsUtils.DoctifyLogo.LOGO_SIZE_EXTRA_SMALL : _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        )
    );
};

var MicroStar_B = exports.MicroStar_B = function MicroStar_B(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default['wrapper_vertical'], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || '', props.isShrinked && _style2.default['wrapper--shrinked'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            {
                className: [props.isShrinked ? '' : _style2.default['mb'], props.isShrinked && _style2.default['stars--shrinked'] || ''].join(' ')
            },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT,
                isShrinked: props.isShrinked
            })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: props.isShrinked ? _widgetsUtils.DoctifyLogo.LOGO_SIZE_EXTRA_SMALL : _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        )
    );
};

var MicroStar_C = exports.MicroStar_C = function MicroStar_C(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default['wrapper_vertical'], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || '', props.isShrinked && _style2.default['wrapper--shrinked'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: props.isShrinked ? _widgetsUtils.DoctifyLogo.LOGO_SIZE_EXTRA_SMALL : _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT,
                isShrinked: props.isShrinked
            })
        )
    );
};

var MicroStar_D = exports.MicroStar_D = function MicroStar_D(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default['wrapper_vertical'], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_ICON,
                logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_LARGE,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT
            })
        )
    );
};

var MicroStar_E = exports.MicroStar_E = function MicroStar_E(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default["wrapper_e"], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            { className: [_style2.default["verbal-rating"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.VerbalRating, { rate: props.averageRating, isRateBold: 'true' })
        ),
        _react2.default.createElement(
            'div',
            { className: [_style2.default["stars"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT
            })
        ),
        _react2.default.createElement(
            'div',
            { className: [_style2.default["align-self-center"], _style2.default["font-size-0"], _style2.default["doctify-logo"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        )
    );
};

var MicroStar_F = exports.MicroStar_F = function MicroStar_F(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default["wrapper_f"], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            { className: [_style2.default["stars"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT
            })
        ),
        _react2.default.createElement(
            'div',
            { className: [_style2.default["align-self-center"], _style2.default["font-size-0"], _style2.default["doctify-logo"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        )
    );
};

var MicroStar_G = exports.MicroStar_G = function MicroStar_G(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default["wrapper_g"], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            { className: [_style2.default["align-self-center"], _style2.default["font-size-0"], _style2.default["doctify-logo"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        ),
        _react2.default.createElement(
            'div',
            { className: [_style2.default["stars"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT
            })
        )
    );
};

var MicroStar_H = exports.MicroStar_H = function MicroStar_H(props) {
    return _react2.default.createElement(
        'a',
        {
            href: props.href,
            className: [_style2.default['wrapper'], _style2.default["align-items-center"], _style2.default["wrapper_h"], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' '),
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            { className: [_style2.default["stars"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT
            })
        ),
        _react2.default.createElement(
            'div',
            { className: [_style2.default["font-size-0"], _style2.default["doctify-logo"]].join(' ') },
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_ICON,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        )
    );
};

var MicroStar_I = exports.MicroStar_I = function MicroStar_I(props) {
    return _react2.default.createElement(
        'a',
        {
            className: [_style2.default['wrapper'], _style2.default['wrapper_vertical'], _style2.default["wrapper_i"], props.blackAndWhiteTheme && _style2.default['text-white'] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame'] || ''].join(' '),
            href: props.href,
            target: '_blank',
            rel: 'nofollow noopener'
        },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                logoTheme: props.blackAndWhiteTheme && _widgetsUtils.DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE || _widgetsUtils.DoctifyLogo.LOGO_THEME_FILLED
            })
        ),
        _react2.default.createElement(
            'div',
            {
                className: [_style2.default['stars--shrinked']].join(' ')
            },
            _react2.default.createElement(_widgetsUtils.Stars, {
                rate: props.averageRating,
                theme: props.blackAndWhiteTheme && _widgetsUtils.Stars.STARS_THEME_BLACK_AND_WHITE || _widgetsUtils.Stars.STARS_THEME_DEFAULT,
                isShrinked: true,
                starItemClassNames: {
                    'mr-3': _style2.default['mr-3']
                }
            })
        ),
        _react2.default.createElement(
            'div',
            {
                className: [_style2.default['numerical-rating'], _style2.default['numerical-rating--smaller'], _style2.default['numerical-rating--bold']].join(' ')
            },
            _react2.default.createElement(_widgetsUtils.NumericalRating, { rate: props.averageRating, isCountBold: 'true' })
        )
    );
};